export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-480w.221cba30.avif";